import ManufacturerSelector from "@components/common/form/manufacturer-selector";
import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
import DeviceTypeSelector from "@components/common/form/device-type-selector";
import ManualAccessNameInput from "@components/common/form/manual-access-field-label-input";
import AccessDeviceLabelInput from "@components/sgt/access-devices/update-access-device/AccessDeviceLabelInput";
import DeviceModelSelector from "@components/common/form/device-model-selector";
import { AccessDeviceTypes } from "@piiqtechnologies/ui-lib";
export const CreateAccessDeviceFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object({
        name: yup.string().required(intl.formatMessage(messages.nameIsRequired)),
    });
};
export const CreateAccessDeviceFormInitialValues = {
    type: "",
    manufacturer: "",
    model: "",
    name: "",
    identifier: "",
};
export const AccessDeviceFormFields = (type = AccessDeviceTypes.KEYBOX) => {
    const intl = useIntl();
    let allFields = {
        accessInfo: [
            {
                id: "type",
                label: intl.formatMessage(messages.deviceTypeLabel),
                placeholder: "",
                required: true,
                columns: 6,
                component: DeviceTypeSelector,
            },
        ],
    };
    // Fields for smart devices
    if (type !== AccessDeviceTypes.CONCIERGE && type !== AccessDeviceTypes.VENDOR) {
        allFields = Object.assign(Object.assign({}, allFields), { keyBoxInfo: [
                {
                    id: "manufacturer",
                    label: intl.formatMessage(messages.manufacturerLabel),
                    placeholder: "",
                    required: false,
                    columns: 6,
                    component: ManufacturerSelector,
                },
                {
                    id: "model",
                    label: intl.formatMessage(messages.modelLabel),
                    placeholder: "",
                    required: false,
                    columns: 6,
                    component: DeviceModelSelector,
                },
                {
                    id: "identifier",
                    label: intl.formatMessage(messages.deviceIdLabel),
                    placeholder: "Ex.: SW-12G",
                    required: false,
                    columns: 6,
                },
                {
                    id: "name",
                    label: intl.formatMessage(messages.nameLabel),
                    placeholder: intl.formatMessage(messages.namePlaceholderWhenKeybox),
                    required: true,
                    columns: 6,
                },
            ] });
        // Fields for manual
    }
    else {
        allFields = Object.assign(Object.assign({}, allFields), { conciergeInfo: [
                {
                    id: "name",
                    label: intl.formatMessage(messages.nameLabelWhenConcierge),
                    placeholder: intl.formatMessage(messages.namePlaceholderWhenConcierge),
                    required: true,
                    columns: 12,
                    component: type !== AccessDeviceTypes.CONCIERGE && type !== AccessDeviceTypes.VENDOR
                        ? AccessDeviceLabelInput
                        : ManualAccessNameInput,
                    infoText: intl.formatMessage(messages.updateFormDeviceNameTooltip),
                },
            ] });
    }
    return allFields;
};
